module.exports = __webpack_public_path__ + "static/img/guiluyaoye.82e6e11f.png";